import { HTTP } from '@/utils/http'
import Apis from '@/apis'
import {safeObj} from "@/utils/safeObj";
import EventBus from "@/eventbus";
import store from '@/store/index'

const GET_TRACK_LIST = 'GET_TRACK_LIST';
const SEARCH_TERM = 'SEARCH_TERM';
const CLEAN_STATE = 'CLEAN_STATE';
const SAVE_SELECTED_BOXES = 'SAVE_SELECTED_BOXES';


const initialState = () => ({
    trackList: null,
    pagination:null,
    trackListLoading: false,
    trackSearch: '',
    trackParams:null,
    selectedBoxes: []
});

export const Boxes = {
    namespaced: true,
    state: initialState,

    mutations: {
        setPaginationPageSize (state, pageSize) {
            state.pagination.pageSize = pageSize
        },
        [GET_TRACK_LIST] (state, {data, loading}) {
            if (data) {
                // Added : pagination (to consume)
                state.pagination = { page: data.page, pageSize: data.pageSize, count:data.count, pageCount: data.pageCount}
                state.trackList = data.items;
            }
            state.trackListLoading = loading
        },
        [SEARCH_TERM] (state, term) {
            console.log(state , term)
            // getTrackList({commit, state}, {stationUid, boxUid, page, pageSize, sortField, sortAscending});
            state.trackSearch = term
            //dispatch('getTrackList', state.trackParams)
        },
        [CLEAN_STATE] (state) {
            state.trackList = null
        },
        [SAVE_SELECTED_BOXES] (state, data) {
            if(data){
                state.selectedBoxes = data
            }
        },
    },
   
    actions: {
        setPaginationPageSize ({ commit }, pageSize) {
            commit('setPaginationPageSize', pageSize)
        },
        getTrackList({commit, state}, {stationUid, boxUid, page, pageSize, sortField, sortAscending, trackSearch}) {
            console.log("getTrackList", {stationUid, boxUid, page, pageSize, sortField, sortAscending , trackSearch});
            state.trackParams = {
                stationUid,
                boxUid,
                page,
                trackSearch : trackSearch,
                pageSize:pageSize||100,
                sortField:sortField,
                sortAscending:sortAscending
            };
            return new Promise((resolve, reject) => {
                commit(GET_TRACK_LIST, {loading: true});
                HTTP.get(Apis.boxes.trackList, {
                    params: state.trackParams})
                    .then(response => {
                        commit(GET_TRACK_LIST, {data: response.data.dataItem, loading: false});
                        const { dataItem, errors, isSuccess } = response.data;
                        resolve({ dataItem, errors, isSuccess });
                    })
                    .catch(error => {
                        commit(GET_TRACK_LIST, {data: [] ,loading: false});
                        reject(error)
                    })
            })
        },
        async moveTrack({ commit }, { position, recordUid, stationUid, boxUid }) {
            try {
                const response = await HTTP.post(Apis.boxes.moveTrack, {
                    position,
                    recordUid,
                    stationUid,
                    boxUid
                });
                const { dataItem, errors, isSuccess } = response.data;
            } catch (error) {
                //
            }
        },
        async moveMultipleTrack({ commit }, { position, recordUids, stationUid, boxUid }) {
            console.log("moveMultipleTrack")
            try {
                const response = await HTTP.post(Apis.boxes.moveTracks, {
                    position,
                    recordUids,
                    stationUid,
                    boxUid
                });
                const { dataItem, errors, isSuccess } = response.data;
            } catch (error) {
                //
            }
        },
        async linkMultipleTrack({ commit,dispatch }, { stationUid, boxUid, trackUids }) {
            console.log("linkMultipleTrack <-")
            try {
                const response = await HTTP.post(Apis.boxes.linkTracks, {
                    stationUid,
                    boxUid,
                    trackUids
                });
                const { dataItem, errors, isSuccess, warnings } = response.data;
                if ((warnings || []).length>0){
                    console.log(response.data, warnings)

                    dispatch('Toasts/addToast', {
                              title: 'Success',
                              message: warnings[0].message,
                              type: 'success'
                    }, {root:true});
                    EventBus.$emit("reFreshLeftMenu");

                }
            } catch (error) {
                //
            }
        },
        repositionTracks({ commit, state }, { recordUid, oldPosition, position }) {
            const repositionnedTracks = state.trackList.map((track) => {
                let updatedTrack = { ...track }
                if (track.linkData.recordUid === recordUid) {
                    updatedTrack = {
                        ...track,
                        linkData: {
                            ...track.linkData,
                            position: position
                        }
                    }
                } else if (oldPosition > position && track.linkData.position >= position && track.linkData.position < oldPosition) {
                    // Moving upwards
                    updatedTrack = {
                        ...track,
                        linkData: {
                            ...track.linkData,
                            position: track.linkData.position + 1
                        }
                    }
                } else if (oldPosition < position && track.linkData.position > oldPosition && track.linkData.position <= position) {
                    // Moving downwards
                    updatedTrack = {
                        ...track,
                        linkData: {
                            ...track.linkData,
                            position: track.linkData.position - 1
                        }
                    }
                }

                return updatedTrack
            })

            commit(GET_TRACK_LIST, {data: repositionnedTracks, loading: false});
        }
    },
    getters: {
        search: state => term => {
            return !!state.trackList && state.trackList.filter(track => {
                if (track.artist == null && track.title == null)
                    return '';

                if (!track.artist && track.artists && track.artists.length > 0) {                        
                        track.artist =  _.join(_.map(track.artists , a => a.name ), ', ')
                }
                
                if (track.artist == null) {
                    track.artist =   '' ;
                }
                
                return track.artist.toLowerCase().includes(term.toLowerCase()) || track.title.toLowerCase().includes(term.toLowerCase())
                   
                
            })
        }
    }
};
